/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_AmountInputs */

const en_admin_credits_amount = /** @type {(inputs: Admin_Credits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

const zh_admin_credits_amount = /** @type {(inputs: Admin_Credits_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数量`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Admin_Credits_AmountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_amount = /** @type {((inputs?: Admin_Credits_AmountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_AmountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_amount(inputs)
	return zh_admin_credits_amount(inputs)
});
export { admin_credits_amount as "admin.credits.amount" }